module.exports = __webpack_public_path__ + "img/news3-1.3ef743fd.png";